export interface Snackbar {
  title?: string;
  showIcon?: boolean;
  durationMs?: number;
  autoClose?: boolean;
  description?: string;
  variant: 'info' | 'success' | 'warning' | 'error';
}

export const useSnackbar = () => {
  const snackbar = useState<Snackbar | null>('snackbar', () => null);

  const add = (data: Snackbar) => {
    snackbar.value = {
      title: data.title,
      variant: data.variant,
      description: data.description,
      showIcon: data.showIcon ?? true,
      autoClose: data.autoClose ?? false,
      durationMs: data.durationMs ?? 2000,
    };

    if (data.autoClose) {
      setTimeout(() => {
        snackbar.value = null;
      }, data.durationMs ?? 2000);
    }
  };

  const remove = () => (snackbar.value = null);

  return { add, remove, snackbar };
};
